import Http from '../API'

const main = {
  state: {
    servers: [],
    auth: null,
    user: {},
    load_page: true,

    visibilityState: true,
    main_title: 'Monitoring',
    other_title: '',

    custom_list: [],
    custom_list_tree: [],

    //clients list
    clients_list: [],
    clients_list_by_id: {},

    //server list
    server_list: [],

    //company_user_list
    company_user_list: [],

    new_comment_text: "",

    permissions: {},

    modules: {},
    datetime_picker: null,
    version_monitoring_front: '',
    settings: {},

    selected_tariffed_device: null,
    selected_client_request: null,
    selected_client_order: null,
    selected_client: null,
    selected_tariff: null,
    selected_apn: null,
    selected_user: null,
    selected_invoice: null,
    selected_ticket: null,

    check_preload: {
      "updatePermissions": false
    }
  },
  getters: {
    getClientById: (state) => (id) => {
      return state.clients_list.find((client) => {
        if (client.id === id) return client
      })
    },
    getNewCommentText: (state) => {
      return state.new_comment_text
    },
    getDatetimePicker: (state) => {
      return state.datetime_picker
    },
    getModules: (state) => {
      return state.modules
    },
    getVersionMonitoringFront: (state) => {
      return state.version_monitoring_front
    },
    getAuth: (state) => {
      return state.auth
    },
    getLoadPage: (state) => {
      return state.load_page
    },
    getPermissions: (state) => {
      return state.permissions
    },
    getCustomList: (state) => {
      return state.custom_list
    },
    getCustomListItemById: (state) => (id) => {
      // (id === null || id === undefined) return null
      const item = state.custom_list.find(item => {
        if (item.id === id) return item
      })
      return item ? item : null
    },
    getCustomListTree: (state) => {
      return state.custom_list_tree
    },
    getClientsList: (state) => {
      return state.clients_list
    },
    getCompanyUserList: (state) => {
      return state.company_user_list
    },
    getClientListById: (state) => (id) => {
      return state.clients_list_by_id[id]
    },
    getUser: (state) => {
      return state.user
    },
    getSettings: (state) =>{
      return state.settings
    },
    getVisibilityState (state) {
      return state.visibilityState
    },
    getServerList (state) {
      return state.server_list
    },
    getSelectedTariffedDevice (state) {
      return state.selected_tariffed_device
    },
    getSelectedClientRequest (state) {
      return state.selected_client_request
    },
    getSelectedClientOrder (state) {
      return state.selected_client_order
    },
    getSelectedClient (state) {
      return state.selected_client
    },
    getSelectedTariff (state) {
      return state.selected_tariff
    },
    getSelectedApn (state) {
      return state.selected_apn
    },
    getSelectedUser (state) {
      return state.selected_user
    },
    getSelectedInvoice (state) {
      return state.selected_invoice
    },
    getSelectedTicket (state) {
      return state.selected_ticket
    }
  },
  mutations: {
    searchChildClient(parent, id, child_list) {
      parent.forEach((element) => {
        if (element.parent_client_id === id){
          child_list.push(element.id)
          if (element.hasChilds === true && element.root !== true){
            main.mutations.searchChildClient(parent, element.id, child_list)
          }
        }
      })
      return child_list
    },
    updateDatetimePicker (state, new_datetime_picker) {
      state.datetime_picker = new_datetime_picker
    },
    addPreloadItems (state, permissions) {
      this.commit('startLoadItem', 'clientsListUpdate')
      this.commit('startLoadItem', 'userSelectOptions')
      this.commit('startLoadItem', 'companyUserListUpdate')

      if (permissions.includes('permissionSupport') || permissions.includes('permissionSupportAdmin')) {
        this.commit('startLoadItem', 'ticketInfo')
      }

      if (permissions.includes('viewSimcardProfile')) {
        this.commit('startLoadItem', 'groupSimcardProfileUpdate')
      }

      if (permissions.includes('viewDeviceGroupList')) {
        this.commit('startLoadItem', 'deviceGroupUpdate')
      }

      if (permissions.includes('viewDeviceSimcardGroups')) {
        this.commit('startLoadItem', 'groupSimcardDevicesUpdate')
      }

      if (permissions.includes('viewCustomDeviceList')) {
        this.commit('startLoadItem', 'customListUpdate')
      }

      if (permissions.includes('permissionGod')) {
        this.commit('startLoadItem', 'updateServerList')
      }
    },

    startLoadItem (state, name) {
      if (!state.check_preload[name]){
        state.check_preload[name] = false
      }

      this.dispatch(name)
    },

    customListUpdate (state, custom_list) {
      state.custom_list = custom_list

      let groups = {}
      state.custom_list.forEach((element) => {
        groups[element.id] = {
          ...element,
          label: element.name,
          search_text: element.name,
          isDefaultExpanded:true,
          expanded: true
        }
      })

      state.custom_list_tree = Object.values(groups)
    },
    clientsListUpdate (state, clients_list) {
      let list= [...clients_list]
      state.clients_list = list.sort((a, b) => a.name > b.name ? 1 : -1)

      let list_by_id = {}
      clients_list.forEach((client) => {
        list_by_id[client.id] = {...client}
      })
      state.clients_list_by_id = list_by_id
    },
    companyUserListUpdate (state, company_user_list) {
      let list= [...company_user_list]
      state.company_user_list = list.sort((a, b) => a.user_name > b.user_name ? 1 : -1)
    },
    updatePermissions (state, permissions) {
      this.commit('addPreloadItems', permissions)

      let object = {}
      for (let permission of permissions) {
        object[permission] = true
      }
      state.permissions = object
    },
    updateMainTitle (state, main_title) {
      state.main_title = main_title
    },
    updateOtherTitle (state, other_title) {
      state.other_title = other_title
    },
    updateVisibilityState (state, new_state) {
      state.visibilityState = new_state
    },
    updateAuth (state, auth) {
      state.auth = auth
    },
    updateModules (state, modules) {
      state.modules = modules
    },
    updateVersionMonitoringFront (state, version) {
      state.version_monitoring_front = version
    },
    updateUser (state, user) {
      state.user = user
    },
    updateLoadPages (state, value) {
      state.load_page = value
    },
    updateSettings(state, settings) {
      state.settings = settings
    },
    updateServerList (state, server_list) {
      state.server_list = server_list
    },
    updateSelectedTariffedDevice (state, selected_tariffed_device) {
      state.selected_tariffed_device = selected_tariffed_device
    },
    updateSelectedClientRequest (state, selected_client_request) {
      state.selected_client_request = selected_client_request
    },
    updateSelectedClientOrder (state, selected_client_order) {
      state.selected_client_order = selected_client_order
    },
    updateSelectedClient (state, selected_client) {
      state.selected_client = selected_client
    },
    updateSelectedTariff (state, selected_tariff) {
      state.selected_tariff = selected_tariff
    },
    updateSelectedApn (state, selected_apn) {
      state.selected_apn = selected_apn
    },
    updateSelectedUser (state, selected_user) {
      state.selected_user = selected_user
    },
    updateSelectedInvoice (state, selected_invoice) {
      state.selected_invoice = selected_invoice
    },
    updateSelectedTicket (state, selected_ticket) {
      state.selected_ticket = selected_ticket
    },
    logout (state) {
      state.servers = []
      state.permissions = {}
      state.check_preload = {
        "updatePermissions": false
      }
      state.auth = false
      location.reload(true)
    },
    donePreloadName(state, name) {
      state.check_preload[name] = true
    },
    startLoading(state){
      for (let name in state.check_preload) {
        this.commit('startLoadItem', name)
      }

      let timer = setInterval(() => {
        let check = true
        for (let name in state.check_preload){
          check = check && state.check_preload[name]
        }
        if (check){
          this.commit('updateLoadPages', false)
          clearInterval(timer)
        }
      }, 100)
    },
    updateNewCommentText(state, new_text) {
      state.new_comment_text = new_text
    },
    clearNewCommentText(state){
      state.new_comment_text = ""
    }
  },
  actions: {
    async updatePermissions () {
      await Http.v1.getUserPermissions((response) => {
        this.commit('updatePermissions', response.data)
        this.commit('donePreloadName', 'updatePermissions')
      })
    },
    async customListUpdate () {
      await Http.v1.getCustomDeviceList((response) => {
        this.commit('customListUpdate', response.data)
        this.commit('donePreloadName', 'customListUpdate')
      })
    },
    async clientsListUpdate () {
      await Http.v1.getClientList((response) => {
        this.commit('clientsListUpdate', response.data)
        this.commit('donePreloadName', 'clientsListUpdate')
      })
    },
    async companyUserListUpdate () {
      await Http.v1.getCompanyUsers((response) => {
        this.commit('companyUserListUpdate', response.data)
        this.commit('donePreloadName', 'companyUserListUpdate')
      })
    },
    async updateServerList () {
      await Http.v1.getServerList((response) => {
        this.commit('updateServerList', response.data)
        this.commit('donePreloadName', 'updateServerList')
      })
    },
    startPreload() {
      this.commit('startLoading')
    },
    checkVisibility() {
      setInterval(() => {
        if (document.visibilityState === 'hidden') {
          this.commit('updateVisibilityState', false)
        }else{
          this.commit('updateVisibilityState', true)
        }
      }, this.getters.getCountdown)
    },
    updateNewCommentText(context, new_text) {
      this.commit('updateNewCommentText', new_text)
    },
    clearNewCommentText() {
      this.commit('clearNewCommentText')
    }
  }
}
export default main
